<template>
  <div style="width: 100%">
    <v-row>
      <v-col cols="12">
        <!-- seleção de unidades -->
        <v-row>
          <select-simple-unidade
            :value="unidade"
            :mapeamento-id="diagnostico.mapeamento.id"
          />
        </v-row>

        <relatorio-gerencial-responsabilidade
          :unidades="unidadesSelecionadasParam"
          is-uma-unidade
          :diagnostico="diagnostico"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SelectSimpleUnidade from '@/components/SelectSimpleUnidade';
import RelatorioGerencialResponsabilidade
from '@/views/monitoramento/desempenho/responsabilidade/tabs/RelatorioGerencialResponsabilidade';

export default {
  name: 'RelatorioGerencialResponsabilidadeUnidade',

  components: { SelectSimpleUnidade, RelatorioGerencialResponsabilidade },

  props: {
    diagnostico: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      unidade: { selecionado: null },
    };
  },

  computed: {
    unidadesSelecionadasParam() {
      const selecionado = this.unidade.selecionado ? [this.unidade.selecionado] : [];
      return {
        isTodasSelecionadas: false,
        selecionado,
      };
    },
  },
};
</script>
